import { __require as requireShim } from '../node_modules/use-sync-external-store/shim/index.mjs';

var shimExports = requireShim();

export { shimExports as s };
//# sourceMappingURL=index2.mjs.map
